import { writable } from 'svelte/store';
const previewAreaLoadingStore = writable(false);
export const removingBg = writable(false);
export default previewAreaLoadingStore;
